import { Route, Routes } from 'react-router-dom'

import { ConfigVersionDiffPage } from '@/features/controller/configuration/pages/ConfigVersionDiffPage'
import { ConfigVersionViewPage } from '@/features/controller/configuration/pages/ConfigVersionViewPage'
import { ControllerConfigurationAppJsonPage } from '@/features/controller/configuration/pages/ControllerConfigurationAppJsonPage'
import { ControllerConfigurationRaspiPropertiesPage } from '@/features/controller/configuration/pages/ControllerConfigurationRaspiPropertiesPage'
import { ControllerConfigurationResourceJsonPage } from '@/features/controller/configuration/pages/ControllerConfigurationResourceJsonPage'
import { ControllerRouteInformation } from '@/features/controller/constants'
import { ControllerByEquipmentNumberPage } from '@/features/controller/pages/ControllerByEquipmentNumberPage'
import { ControllerDetailsPage } from '@/features/controller/pages/ControllerDetailsPage'
import { ControllersPage } from '@/features/controller/pages/ControllersPage'

export default function ControllersRoutes() {
  return (
    <Routes>
      <Route index element={<ControllersPage />} />
      <Route
        element={<ControllerByEquipmentNumberPage />}
        path={ControllerRouteInformation.CONTROLLER_BY_EQUIPMENT_NUMBER.routePath}
      />
      <Route element={<ControllerDetailsPage />} path={ControllerRouteInformation.CONTROLLER_DETAILS.routePath} />
      <Route
        element={<ControllerConfigurationRaspiPropertiesPage />}
        path={ControllerRouteInformation.CONTROLLER_CONFIG_RASPI_PROPERTIES.routePath}
      />
      <Route
        element={<ControllerConfigurationAppJsonPage />}
        path={ControllerRouteInformation.CONTROLLER_CONFIG_APP_JSON.routePath}
      />
      <Route
        element={<ControllerConfigurationResourceJsonPage />}
        path={ControllerRouteInformation.CONTROLLER_CONFIG_RESOURCE_JSON.routePath}
      />
      <Route element={<ConfigVersionViewPage />} path={ControllerRouteInformation.CONTROLLER_CONFIG_VIEW.routePath} />
      <Route element={<ConfigVersionDiffPage />} path={ControllerRouteInformation.CONTROLLER_CONFIG_DIFF.routePath} />
    </Routes>
  )
}
